import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ControlsNgModule } from '@seech/controls-ng';
import { IconsNgModule } from '@seech/icons-ng';
import { AutomationDriftWarningService } from '../../services';

@Component({
  standalone: true,
  selector: 'app-automation-drift-warning',
  imports: [CommonModule, ControlsNgModule, FormsModule, IconsNgModule],
  templateUrl: './automation-drift-warning.component.html',
  styleUrls: ['./automation-drift-warning.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutomationDriftWarningComponent {
  readonly warningService = inject(AutomationDriftWarningService);
  readonly state$ = this.warningService.state$;
}
